import { GeneralEnumsApi } from 'api/general-enums';
import { autoinject } from 'aurelia-framework';
import { ApprovalStatus, TransportationSystemType, AirlineRating, AirlineStatus, DeviationType, DeviationWorkflowType, DeviationDetailType, DeviationRequestStatus, ClassOfTravel, FlightTime, LocationCurrentnessStatus } from 'model/business-enums';
import { ApproveType, CountryApprovalRequirement } from 'api/swagger/ApiClient';
import { EnumBase, EnumInfo } from 'model/platform-types';
import { ServiceBase } from 'support/base_classes/service-base';

@autoinject
export class EnumsService extends ServiceBase {
  approvalStatuses: EnumInfo<ApprovalStatus>[] = [];
  approvalTypes: EnumInfo<ApproveType>[] = [];
  approvalRequirements: EnumInfo<CountryApprovalRequirement>[] = [];
  airlineRatings: EnumInfo<AirlineRating>[] = [];
  airlineStatuses: EnumInfo<AirlineStatus>[] = [];
  classesOfTravel: EnumInfo<ClassOfTravel>[] = [];
  deviationTypes: EnumInfo<DeviationType>[] = [];
  deviationWorkflowTypes: EnumInfo<DeviationWorkflowType>[] = [];
  deviationDetailTypes: EnumInfo<DeviationDetailType>[] = [];
  deviationRequestStatuses: EnumInfo<DeviationRequestStatus>[] = [];
  flightTimes: EnumInfo<FlightTime>[] = [];
  locationCurrentnessStatuses: EnumInfo<LocationCurrentnessStatus>[] = [];
  transportDataTypes: EnumInfo<TransportationSystemType>[] = [];

  constructor(private api: GeneralEnumsApi) {
    super();
  }

  protected async initializeService() {
    await this.reload();
  }

  async reload() {
    const enums = await this.api.getApplicationEnums();
    this.approvalStatuses = enums.approvalStatuses;
    this.approvalTypes = enums.approvalTypes;
    this.approvalRequirements = enums.approvalRequirements;
    this.airlineRatings = enums.airlineRatings;
    this.airlineStatuses = enums.airlineStatuses;
    this.classesOfTravel = enums.classesOfTravel;
    this.deviationTypes = enums.deviationTypes;
    this.deviationWorkflowTypes = enums.deviationWorkflowTypes;
    this.deviationDetailTypes = enums.deviationDetailTypes;
    this.deviationRequestStatuses = enums.deviationRequestStatuses;
    this.flightTimes = enums.flightTimes;
    this.locationCurrentnessStatuses = enums.locationCurrentnessStatuses;
    this.transportDataTypes = enums.transportDataTypes;
  }

  ensureItem<T extends EnumBase<T>>(list: EnumInfo<T>[], item: EnumInfo<T>, replace = false) {
    return item == null ? list : !list.some(i => this.itemsMatch(i, item)) ? [...list, item] : list.map(i => this.itemsMatch(i, item) && !replace ? item : i);
  }

  itemsMatch<T extends EnumBase<T>>(x: EnumInfo<T>, y: EnumInfo<T>) {
    if (x == null && y == null) return true;
    if (x == null || y == null) return false;
    return x === y || x.value === y.value;
  }
}
